






































































































































import Vue from "vue";
import SkillRate from "@/components/SkillRate.vue";
import Accent from "@/components/Accent.vue"; // Adjust the import path as necessary

export default Vue.extend({
  name: "Resume",
  components: {
    SkillRate,
    Accent,
  },
});
